import axios from 'axios';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
import { Controller } from "stimulus";

import { isBlank, secondsToHours } from '../../commons.js';

/*
 * l'id de la task est dans la datamap de stimulus, initialisé dans le <tr task body>
 */

export default class extends Controller {

  static targets = ["timerValue"]

  connect() {
    if (this.element.dataset.timerState === 'running') {
      this.update_timer();
      this.timer_id = setInterval(() => {
        this.update_timer();
      }, 1000);
    } else {
      this.timer_id = null
    }

    this.evtL1 = this.evtHeaderRefresh.bind(this); // https://stackoverflow.com/questions/11565471/removing-event-listener-which-was-added-with-bind
    // Reçu si changement d'état du timer d'une task
    document.addEventListener('@timer-header#refresh', this.evtL1, false); // Sans evtL1 le bind de add et de remove ne sont pas les mêmes, et du coup le remove ne supprime pas le listener
  }

  disconnect() {
    if (this.timer_id) {
      clearInterval(this.timer_id)
    }
    document.removeEventListener('@timer-header#refresh', this.evtL1, false)
  }

  evtHeaderRefresh(e) {
    axios.get('/daily/header_timer')
      .then(response => {
        this.element.outerHTML = response.data
      })
  }

  update_timer() {
    var current = this.timerValueTarget.dataset.value++
    this.timerValueTarget.innerHTML = secondsToHours(current)
  }

  timer_change(e) {
    e.preventDefault()
    axios.put(e.target.getAttribute('href')).then(response => {
      this.element.outerHTML = response.data;
      document.dispatchEvent(new CustomEvent('@daily-filter#refresh', {
        'detail': 'tasks'
      }));
    })
  }

}